module.exports = __webpack_public_path__ + "static/media/zr_2_7.a44ad0d0.png";